export default __webpack_public_path__ + "media/images/images/banner/banner-39-7081a95833fe2291c0a1f09dfc65262f.jpg";